import {Component, inject, Input, ChangeDetectionStrategy} from '@angular/core';
import {IonButton, IonContent, ModalController} from "@ionic/angular";
import {FaIconComponent, IconDefinition} from "@fortawesome/angular-fontawesome";
import {faUserGroup, faUser, faBell, faGear, faPen} from "@fortawesome/sharp-light-svg-icons";
import {TranslatePipe} from "@ngx-translate/core";
import {UserModel} from "../../models/user.model";
import {UserAvatarComponent} from '../../components/user-avatar/user-avatar.component';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonButton,
    IonContent,
    FaIconComponent,
    TranslatePipe,
    UserAvatarComponent,
    RouterLink,
  ]
})
export class UserMenuComponent {
  @Input() user: UserModel |null = null;
  private modalController: ModalController = inject(ModalController);

  async closeModal(){
    await this.modalController.dismiss(null, 'cancel', 'userMenu');
  }

  protected readonly faUser: IconDefinition = faUser;
  protected readonly faBell: IconDefinition = faBell;
  protected readonly faUserGroup: IconDefinition = faUserGroup;
  protected readonly faGear: IconDefinition = faGear;
  protected readonly faPen: IconDefinition = faPen;
}
